// import bezier from 'bezier-easing';

// const defaultBezier = bezier(0.3, 0, 0.1, 1);
const defaultBezier = x => x;
export default {
  data() {
    return {
      bezierMap: {},
      rAFUpdateMap: {},
      updateCountMap: {},
      preUpdateTime: {}
    };
  },
  methods: {
    // bezier 动画
    updateBezier(type, target, duration = 100, endTime, startProgress) {
      const currentTime = +new Date();
      if (!this.updateCountMap[type]) {
        this.updateCountMap[type] = 0;
      }
      this.updateCountMap[type]++;
      if (this.updateCountMap[type] <= 2) {
        duration = 0;
      }

      if (!endTime) {
        endTime = currentTime + duration;
        // 第一次进来
        if (this.rAFUpdateMap[type]) {
          cancelAnimationFrame(this.rAFUpdateMap[type]);
          this.rAFUpdateMap[type] = null;
          // 修改duration，保证反复触发updatebezier的是偶，动画可以衔接上
          duration += Math.max(0, currentTime - this.preUpdateTime[type]) + duration;
        }
        startProgress = this[type];
      }

      if (currentTime >= endTime || Math.abs(target - this[type]) < 0.0005) {
        this[type] = target;
        this.rAFUpdateMap[type] = null;
        return;
      } else {
        this[type] =
          startProgress +
          (target - startProgress) * (this.bezierMap[type] || defaultBezier)(1 - (endTime - currentTime) / duration);
        this.preUpdateTime[type] = currentTime;
        this.rAFUpdateMap[type] = requestAnimationFrame(() =>
          this.updateBezier(type, target, duration, endTime, startProgress)
        );
      }
    }
  }
};
